/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Meetings_Exception_CancelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_cancel = /** @type {((inputs?: Meetings_Exception_CancelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_CancelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Annuleren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	return /** @type {LocalizedString} */ ("Cancel")
});